/**
 * 物件詳細 PC メインスライダー：サムネホバーでキャプション表示
 */
export function initBukkenDetailMainCaption(mainEl, mainSlider, thumbEl) {
	if (!mainEl || !mainSlider) return;
	if (!window.matchMedia('(min-width: 768px)').matches) return;

	let showCaptionOnNextMove = false;

	function getThumbListSlides() {
		if (!thumbEl) return [];
		return thumbEl.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)');
	}

	function markCaptionOnNextMove() {
		showCaptionOnNextMove = true;
	}

	function handleThumbCaptionTrigger(slide) {
		markCaptionOnNextMove();
		const slides = getThumbListSlides();
		const index = Array.prototype.indexOf.call(slides, slide);
		if (index >= 0 && mainSlider.index === index) {
			mainEl.classList.add('is-caption-open');
			showCaptionOnNextMove = false;
		}
	}

	getThumbListSlides().forEach((slide) => {
		const btn = slide.querySelector('.bukkenDetail__thumb');
		if (!btn) return;
		btn.addEventListener('mouseenter', () => handleThumbCaptionTrigger(slide));
	});

	const thumbWrap = thumbEl?.closest('.bukkenDetail__thumbWrap');
	if (thumbWrap) {
		thumbWrap.addEventListener('mouseleave', (event) => {
			const related = event.relatedTarget;
			if (related instanceof Node && mainEl.contains(related)) return;
			mainEl.classList.remove('is-caption-open');
		});
	}

	mainEl.addEventListener('mouseleave', (event) => {
		const related = event.relatedTarget;
		if (related instanceof Node && thumbWrap?.contains(related)) return;
		mainEl.classList.remove('is-caption-open');
	});

	mainSlider.on('moved', () => {
		if (showCaptionOnNextMove) {
			mainEl.classList.add('is-caption-open');
			showCaptionOnNextMove = false;
		}
	});
}
